'use client'; // This is a client component 👈🏽

import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Container from 'components/Container';
// import TopNav from 'components/TopNav';
import type { SxProps, Theme } from '@mui/material';
import MobileFooter from './components/Footer/MobileFooter';
import { Topbar, Sidebar, Footer } from './components';
import pages from '../navigation';

interface Props {
  children: React.ReactNode;
  colorInvert?: boolean;
  bgcolor?: string;
  logoColor?: string;
  footColor?: SxProps<Theme>;
}

const Main = ({
  children,
  colorInvert = false,
  bgcolor = 'transparent',
  logoColor,
  footColor,
}: Props): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = (): void => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = (): void => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  console.log('isMd>>', isMd);

  return (
    <Box>
      {/* <Box bgcolor={bgcolor} position={'relative'} zIndex={theme.zIndex.appBar}>
        <Container paddingTop={'8px !important'} paddingBottom={'0 !important'}>
          <TopNav colorInvert={colorInvert} />
        </Container>
      </Box> */}
      <AppBar
        position={'sticky'}
        sx={{
          top: 0,
          backgroundColor: trigger ? theme.palette.background.paper : bgcolor,
        }}
        elevation={trigger ? 1 : 0}
      >
        <Container paddingY={1}>
          <Topbar
            onSidebarOpen={handleSidebarOpen}
            pages={pages}
            colorInvert={trigger ? false : colorInvert}
            logoColor={logoColor}
          />
        </Container>
      </AppBar>
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
        logoColor={logoColor}
      />
      <main>{children}</main>
      <Container
        paddingY={0}
        paddingX={0}
        // sx={{ bgcolor: '#171C61', ...footColor }}
        sx={{ bgcolor: '#1e40af', ...footColor }}
        maxWidth={'100%'}
      >
        {isMd ? <Footer /> : <MobileFooter />}
      </Container>
    </Box>
  );
};

export default Main;
